module.exports = __webpack_public_path__ + "img/ossz_hossz.9f1106bc.svg";